import React, { useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Empty } from "./ui";
import { Upload, FileText, Trash2, ExternalLink } from "lucide-react";
import { API } from "../../lib/api";

export default function FilesPanel({ bid, files, onChange, compact }) {
  const [uploading, setUploading] = useState(false);
  const token = localStorage.getItem("lr_token");

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      await api.post(`/businesses/${bid}/files`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Uploaded");
      onChange && onChange();
    } catch { toast.error("Upload failed"); }
    finally { setUploading(false); e.target.value = ""; }
  };

  const del = async (f) => {
    if (!window.confirm("Delete this file?")) return;
    await api.delete(`/files/${f.id}`);
    onChange && onChange();
  };

  return (
    <div data-testid="files-panel">
      <div className="flex items-center justify-between mb-3">
        {!compact && <h3 className="font-serif text-xl text-lr-charcoal">Files</h3>}
        <label className="ml-auto">
          <input type="file" className="hidden" onChange={upload} data-testid="file-upload-input"
            accept="image/*,application/pdf,.csv,.xlsx,.docx,.txt" />
          <span className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-[4px] bg-lr-olive text-lr-cream cursor-pointer hover:bg-[#3d4230]">
            <Upload className="h-3.5 w-3.5" /> {uploading ? "Uploading…" : "Upload"}
          </span>
        </label>
      </div>
      {(!files || files.length === 0) ? <Empty>No files attached.</Empty> : (
        <div className="space-y-2">
          {files.map((f) => (
            <div key={f.id} className="lr-card p-3 flex items-center gap-3" data-testid={`file-${f.id}`}>
              <FileText className="h-4 w-4 text-lr-leather flex-shrink-0" />
              <span className="text-sm text-lr-charcoal flex-1 min-w-0 truncate">{f.original_filename}</span>
              <a href={`${API}/files/${f.id}/download?auth=${token}`} target="_blank" rel="noreferrer" className="p-1 text-lr-leather hover:text-lr-olive"><ExternalLink className="h-4 w-4" /></a>
              <button onClick={() => del(f)} className="p-1 text-lr-leather hover:text-lr-rose"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
